const errorTags = ({ err }) => {
  const { stack, message, response } = err;

  return {
    stackTrace: stack,
    errorMessage: message,
    statusText: response?.statusText,
    statusCode: response?.status,
    response: response?.data && JSON.stringify(response.data),
  };
};

export default errorTags;
